var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.status
    ? _c(
        "div",
        {
          staticClass: "modal fade",
          class: { in: _vm.status },
          staticStyle: { display: "block" }
        },
        [
          _c("div", {
            staticClass: "dialog-background",
            staticStyle: { "z-index": "405", background: "#000" },
            on: {
              click: function($event) {
                return _vm.$emit("clickBackground")
              }
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "modal-dialog", staticStyle: { "z-index": "405" } },
            [
              _c("div", { staticClass: "modal-content" }, [
                _vm.header
                  ? _c("div", { staticClass: "modal-header" }, [
                      _c(
                        "button",
                        {
                          staticClass: "close",
                          attrs: { type: "button" },
                          on: { click: _vm.close }
                        },
                        [
                          _c("span", { attrs: { "aria-hidden": "true" } }, [
                            _vm._v("×")
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      !!_vm.title
                        ? _c("h4", { staticClass: "modal-title" }, [
                            _vm._v(_vm._s(_vm.title))
                          ])
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [_vm._t("body")], 2),
                _vm._v(" "),
                _vm.footer
                  ? _c(
                      "div",
                      { staticClass: "modal-footer" },
                      [_vm._t("footer")],
                      2
                    )
                  : _vm._e()
              ])
            ]
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-673bab72", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-673bab72","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/webpack/vue/components/Modal.vue
// module id = 109
// module chunks = 0